/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Security_Passkey_Last_HintInputs */



/**
* | output |
* | --- |
* | "You cannot remove your only passkey. Add another one first." |
*
* @param {Partner_Security_Passkey_Last_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_security_passkey_last_hint = /** @type {((inputs?: Partner_Security_Passkey_Last_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Security_Passkey_Last_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie können Ihren einzigen Passkey nicht entfernen. Fügen Sie zuerst einen weiteren hinzu.")
	return /** @type {LocalizedString} */ ("You cannot remove your only passkey. Add another one first.")
});